import { INPUT_VARIANT } from "@/common/elements/InputElements/const";
import TextField from "@/common/elements/InputElements/TextField";
import {
  IntakeSectionHeader,
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
  StyledTypographyText,
} from "@/common/styles";
import { forwardRef } from "react";
import { Col, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import CommonDatePicker from "@/common/elements/DatePicker";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import { isNonEmptyVariable } from "@/util/common_function";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

const DeadlineInformation = forwardRef(({ deadlineStartDateTime }, ref) => {
  const { bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  return (
    <>
      <IntakeSectionHeader ref={ref}>
        <span>Deadline Information</span>
      </IntakeSectionHeader>
      <FormContainer>
        <StyledGridRow gutter={16}>
          <StyledGridCol span={8}>
            <FormItem
              name="deadlineStartDateTime"
              label="Deadline Start Date/Time"
              layout="vertical"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY HH:mm"
                format="MM/DD/YYYY HH:mm"
                showTime={true}
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={6}>
            <FormItem
              name="deadlineDateTime1Local"
              label="36-Hour Court Appearance"
              layout="vertical"
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY HH:mm"
                format="MM/DD/YYYY HH:mm"
                showTime={true}
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={13}>
            <FormItem
              name="deadlineSatisfied1"
              layout="horizontal"
              labelPostion="label-right"
              label="Inmate had a court appearance (36-hour criteria met)?"
              valuePropName="checked"
            >
              <Checkbox disabled={!bookingsFieldsEnabled} />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={5}>
            <FormItem
              label="Satisifed Date/Time"
              name="deadlineSatisfiedDateTime1"
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY HH:mm"
                format="MM/DD/YYYY HH:mm"
                showTime={true}
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={6}>
            <FormItem
              name="deadlineDateTime2Local"
              label="48-Hour Probable Cause"
              layout="vertical"
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY HH:mm"
                format="MM/DD/YYYY HH:mm"
                showTime={true}
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={13}>
            <FormItem
              name="deadlineSatisfied2"
              layout="horizontal"
              labelPostion="label-right"
              label="Inmate has probable cause paperw ork (48-hour criteria met)?"
              valuePropName="checked"
            >
              <Checkbox disabled={!bookingsFieldsEnabled} />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={5}>
            <FormItem
              label="Satisifed Date/Time"
              name="deadlineSatisfiedDateTime2"
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY HH:mm"
                format="MM/DD/YYYY HH:mm"
                showTime={true}
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </FormContainer>
    </>
  );
});

export default DeadlineInformation;
